import React, { useState } from 'react';
import { User, Ship, Car } from 'lucide-react';
import { Progress } from "../components/ui/progress";
import Navbar from '../components/Navbar';
import DatosCliente from '../components/DatosCliente';
import DatosEmbarcacion from '../components/DatosEmbarcacion';
import DatosVehiculo from '../components/DatosVehiculo';


const NuevoClientePage = () => {
  const [paso, setPaso] = useState(1);
  const [cliente, setCliente] = useState({
    nombre: '',
    apellido: '',
    dni: '',
    telefono1: '',
    telefono2: '',
    vencimientoLicencia: '',
    observaciones: ''
  });
  const [clienteId, setClienteId] = useState(null); // Declarado una sola vez aquí.
  const [embarcacion, setEmbarcacion] = useState({
    numeroMatricula: '',
    vencimientoMatricula: '',
    tipoEmbarcacion: '',
    colorCasco: '',
    capacidad: '',
    hp: '',
    nombreFantasia: '',
    seguro: '',
    vencimientoSeguro: ''
  });
  const [vehiculo, setVehiculo] = useState({
    patente: '',
    marca: '',
    anio: '',
    color: ''
  });

  const pasos = [
    { numero: 1, titulo: 'Datos del Cliente', icono: <User className="h-5 w-5" /> },
    { numero: 2, titulo: 'Datos de la Embarcación', icono: <Ship className="h-5 w-5" /> },
    { numero: 3, titulo: 'Datos del Vehículo', icono: <Car className="h-5 w-5" /> },
  ];

  console.log('Estado actual de paso:', paso);  // Verificar el paso actual
  console.log('Estado de cliente antes de paso 1:', cliente); // Verificar datos del cliente
  console.log('Estado de clienteId antes de paso 2:', clienteId); // Verificar clienteId antes de paso 2
  console.log('Estado de embarcacion antes de paso 3:', embarcacion); // Verificar datos de embarcación
  console.log('Estado de vehiculo antes de paso 3:', vehiculo); // Verificar datos de vehículo

  return (
    <div className="min-h-screen bg-gradient-to-b">
      <Navbar />

      <main className="container mx-auto mt-8 px-4">
        <h1 className="text-4xl text-azul-oscuro font-bold mb-8">Nuevo Cliente</h1>

        {/* Barra de progreso */}
        <div className="mb-8">
          <Progress value={(paso / 3) * 100} className="h-2" />
          <div className="flex justify-between mt-2">
            {pasos.map((step) => (
              <div
                key={step.numero}
                className={`flex flex-col items-center ${paso >= step.numero ? 'text-blue-300' : 'text-blue-500'}`}
              >
                <div
                  className={`rounded-full p-2 ${paso >= step.numero ? 'bg-blue-500' : 'bg-blue-700'}`}
                >
                  {step.icono}
                </div>
                <span className="text-xs mt-1">{step.titulo}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Renderizado condicional de los pasos */}
        {paso === 1 && (
          <DatosCliente
            cliente={cliente}
            setCliente={setCliente}
            setPaso={setPaso}
            setClienteId={setClienteId}
          />
        )}
        {paso === 2 && (
          <DatosEmbarcacion
            embarcacion={embarcacion}
            setEmbarcacion={setEmbarcacion}
            setPaso={setPaso}
            clienteId={clienteId} // Se pasa el clienteId aquí.
          />
        )}
        {paso === 3 && (
          <>
            {console.log('Cliente ID antes de DatosVehiculo:', clienteId)}  {/* Verificar clienteId antes de paso 3 */}
            {console.log('Estado de vehiculo antes de DatosVehiculo:', vehiculo)}  {/* Verificar datos de vehiculo */}
            <DatosVehiculo
              vehiculo={vehiculo}
              setVehiculo={setVehiculo}
              setPaso={setPaso}
              cliente_id={clienteId} // También se pasa el clienteId aquí.
            />
          </>
        )}

      </main>
    </div>
  );
};

export default NuevoClientePage;
